module.exports = __webpack_public_path__ + "img/document-text.7c4ca05b.svg";